export default __webpack_public_path__ + "static/media/CimmerianEndCentral.21e601cb.jpg";